import FormControlLabel from '@mui/material/FormControlLabel';
import { useState } from 'react';
import { TextField } from '@mui/material';
import { IOSSwitch } from '../common/IosSwitch';
import Collapse from '@mui/material/Collapse';
import { useDispatch, useSelector } from 'react-redux';
import { UPDATE_SECOND_BUYER_INFO } from '../../redux-state/forms/types';
import { selectSecondBuyerInfo } from '../../redux-state/selectors';

function SecondBuyerInformation() {
  const [isFieldVisible, setIsFieldVisible] = useState(false);
  const secondBuyerInfo = useSelector(selectSecondBuyerInfo);
  const dispatch = useDispatch();

  const handleChange = (key, value) => {
    dispatch({
      type: UPDATE_SECOND_BUYER_INFO,
      payload: { key, value },
    });
  };

  return (
    <div>
      <div className={`flex flex-row justify-between p-4 ${isFieldVisible ? 'rounded-t-xl' : 'rounded-xl'} bg-white text-gray-700`}>
        <div className="text-md font-bold">Second Buyer Information</div>
        <div className="flex flex-row">
          <div className="mt-1">{isFieldVisible ? 'Hide Detail' : 'Show Detail'}</div>
          <FormControlLabel
            control={<IOSSwitch sx={{ ml: 3 }} checked={isFieldVisible} onChange={(e) => setIsFieldVisible(e.target.checked)} />}
          />
        </div>
      </div>

      <Collapse in={isFieldVisible} timeout={500} unmountOnExit>
        <div className="flex flex-col bg-white p-4 gap-4 rounded-b-xl text-gray-900">
          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Secondary Buyer First Name"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerFirstName}
              onChange={(e) => handleChange('secondBuyerFirstName', e.target.value)}
            />
            <TextField
              label="Secondary Buyer Middle Name"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerMiddleName}
              onChange={(e) => handleChange('secondBuyerMiddleName', e.target.value)}
            />
            <TextField
              label="Secondary Buyer Last Name"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerLastName}
              onChange={(e) => handleChange('secondBuyerLastName', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Secondary Buyer Company Name"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerCompanyName}
              onChange={(e) => handleChange('secondBuyerCompanyName', e.target.value)}
            />
            <TextField
              label="Secondary Buyer Address Line 1"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerAddressLine1}
              onChange={(e) => handleChange('secondBuyerAddressLine1', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Secondary Buyer Address Line 2"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerAddressLine2}
              onChange={(e) => handleChange('secondBuyerAddressLine2', e.target.value)}
            />
            <TextField
              label="Secondary Buyer City"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerCity}
              onChange={(e) => handleChange('secondBuyerCity', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Secondary Buyer State"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerState}
              onChange={(e) => handleChange('secondBuyerState', e.target.value)}
            />
            <TextField
              label="Secondary Buyer Zip"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerZip}
              onChange={(e) => handleChange('secondBuyerZip', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Secondary Buyer Date of Birth"
              type="date"
              variant="outlined"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={secondBuyerInfo?.secondBuyerDob}
              onChange={(e) => handleChange('secondBuyerDob', e.target.value)}
            />
            <TextField
              label="Secondary Buyer SSN"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerSsn}
              onChange={(e) => handleChange('secondBuyerSsn', e.target.value)}
            />
          </div>

          <div className="flex flex-col md:flex-row gap-4">
            <TextField
              label="Secondary Buyer Driver's License Number"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerLicenseNumber}
              onChange={(e) => handleChange('secondBuyerLicenseNumber', e.target.value)}
            />
            <TextField
              label="Secondary Buyer Driver's License State"
              variant="outlined"
              fullWidth
              value={secondBuyerInfo?.secondBuyerLicenseState}
              onChange={(e) => handleChange('secondBuyerLicenseState', e.target.value)}
            />
          </div>
        </div>
      </Collapse>
    </div>
  );
}

export default SecondBuyerInformation;
